import {AddressModel} from './address.model';

export class AccidentModel {
	type_accident: string | AccidentType;
	responsible: boolean;
	date_accident: Date;
	happened_abroad: boolean;
	address: AddressModel;
	damage_to_objects?: boolean;
	damage_to_vehicles: boolean;
	old_motorcycle_plates: string;
	intervention_authority: boolean;
	police: boolean;
	cc: boolean;
	vvuu: boolean;
	authority_data: string;
	witness_description: string;
	recoverability: boolean;
	recoverability_percent: number;
	incomplete_motivation: string;
	is_robbery: boolean;
	center_notified: boolean;
	happened_on_center: boolean;
	provider_code: string;
	theft_description: string;
	item_to_receive: ReceivedItem[];
	is_with_counterparty?: boolean;
	cc_poste?: string;

	constructor() {
		// this.item_to_receive = [];
	}
}

export class ReceivedItem {
	is_received: boolean;
	type: ItemToReceiveType;
	date_received: Date;
	report: string;
	note: string;
}

export enum AccidentType {
	CARD_NON_VERIFICABILE_FIRMA_SINGOLA = 'CARD_NON_VERIFICABILE_FIRMA_SINGOLA',
	CARD_ATTIVA_FIRMA_SINGOLA = 'CARD_ATTIVA_FIRMA_SINGOLA',
	CARD_PASSIVA_FIRMA_SINGOLA = 'CARD_PASSIVA_FIRMA_SINGOLA',
	CARD_CONCORSUALE_FIRMA_SINGOLA = 'CARD_CONCORSUALE_FIRMA_SINGOLA',
	CARD_NON_VERIFICABILE_DOPPIA_FIRMA = 'CARD_NON_VERIFICABILE_DOPPIA_FIRMA',
	CARD_ATTIVA_DOPPIA_FIRMA = 'CARD_ATTIVA_DOPPIA_FIRMA',
	CARD_PASSIVA_DOPPIA_FIRMA = 'CARD_PASSIVA_DOPPIA_FIRMA',
	CARD_CONCORSUALE_DOPPIA_FIRMA = 'CARD_CONCORSUALE_DOPPIA_FIRMA',
	KASKO_URTO_CONTRO_OGGETTI_FISSI = 'KASKO_URTO_CONTRO_OGGETTI_FISSI',
	ATTO_VANDALICO = 'ATTO_VANDALICO',
	DANNO_RITROVATO_IN_PARCHEGGIO = 'DANNO_RITROVATO_IN_PARCHEGGIO',
	EVENTI_NATURALI = 'EVENTI_NATURALI',
	RC_NON_VERIFICABILE = 'RC_NON_VERIFICABILE',
	RC_ATTIVA = 'RC_ATTIVA',
	RC_PASSIVA = 'RC_PASSIVA',
	RC_CONCORSUALE = 'RC_CONCORSUALE',
	CRISTALLI = 'CRISTALLI',
	CHIAVI_SMARRITE_RUBATE = 'CHIAVI_SMARRITE_O_RUBATE',
	INCENDIO = 'INCENDIO',
	TENTATO_FURTO = 'TENTATO_FURTO',
	FURTO_PARZIALE = 'FURTO_PARZIALE',
	FURTO_TOTALE = 'FURTO_TOTALE',
	FURTO_RITROVAMENTO = 'FURTO_E_RITROVAMENTO',
}

export enum ItemToReceiveType {
	FIRST_KEY = 'FIRST_KEY',
	SECOND_KEY = 'SECOND_KEY',
	ORIGINAL_COMPLAINT = 'ORIGINAL_COMPLAINT',
}

export enum ChargebackType {
	TOTAL_REBILL = 'Total Rebill',
	NO_REBILL = 'No Rebill',
	DEDUCTIBLE = 'Deductible'
}

export const ClaimActiveTypeList: AccidentType[] = [AccidentType.CARD_ATTIVA_FIRMA_SINGOLA, AccidentType.CARD_ATTIVA_DOPPIA_FIRMA, AccidentType.RC_ATTIVA];
export const ClaimPassiveTypeList: AccidentType[] = [AccidentType.CARD_PASSIVA_FIRMA_SINGOLA, AccidentType.CARD_PASSIVA_DOPPIA_FIRMA, AccidentType.RC_PASSIVA];
export const ClaimConcorsualeTypeList: AccidentType[] = [AccidentType.CARD_CONCORSUALE_FIRMA_SINGOLA, AccidentType.CARD_CONCORSUALE_DOPPIA_FIRMA, AccidentType.RC_CONCORSUALE];
